<template>
    <div class="price-container broker">
        <div class="price-value" v-if="info.listingStatus == 'Sold'">
            <p class="price_all">
                <no-disclosure
                    v-if="!!info.nodisclosureDes || hidePrice"
                    :des="
                        hidePrice
                            ? $t('md-detail-info.nondisclosure')
                            : info.nodisclosureDes
                    "
                ></no-disclosure>
                <span v-else class="sold-price">
                    {{
                        $ft.formatCurrency({
                            value: showSoldPrice ? info.soldPrice : info.price,
                            currencySymbol
                        })
                    }}
                </span>
            </p>
            <p
                v-if="
                    showListingPrice &&
                        showSoldPrice &&
                        info.nodisclosureDes == null
                "
                class="trend-price"
            >
                <span class="initial-price">{{
                    $ft.formatCurrency({value: info.price, currencySymbol})
                }}</span>
                <span
                    v-if="
                        info.price &&
                            info.soldPrice != info.price &&
                            trend !== '0.0%'
                    "
                    class="house-trend"
                    :class="{
                        up: info.soldPrice > info.price,
                        down: info.soldPrice < info.price
                    }"
                >
                    <span class="iconfont icon-trend-up"></span>
                    <span class="iconfont icon-trend-down"></span>
                    {{ trend }}
                </span>
            </p>
        </div>
        <div class="origin-price" v-else>
            <no-disclosure
                v-if="!!info.nodisclosureDes || hidePrice"
                :des="
                    hidePrice
                        ? $t('md-detail-info.nondisclosure')
                        : info.nodisclosureDes
                "
            ></no-disclosure>
            <span class="price-number" v-else>
                {{ $ft.formatCurrency({ value:info.price, currencySymbol}) }}
            </span>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import noDisclosure from '../../../../components/nodisclosure';
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    data: function() {
        return {};
    },
    components: { noDisclosure },
    computed: {
        ...rootMapState(usePageStore, {
            "house": store => store.page?.house || {},
            "currencySymbol": store => store.currency?.symbol
        }),
        ...mapState({
            "info": store => store.listingDetail.info || {}
        }),
        trend() {
            if (this.info.price) {
                return (
                    (
                        (Math.abs(this.info.soldPrice - this.info.price) /
                            this.info.price) *
                        100
                    ).toFixed(1) + '%'
                );
            } else {
                return '0.0%';
            }
        },
        showSoldPrice() {
            return (
                this.house.showSoldPrice && this.info.listingStatus == 'Sold'
            );
        },
        showListingPrice() {
            return (
                this.house.showListingPrice && this.info.listingStatus == 'Sold'
            );
        },
        hidePrice() {
            return (
                !this.house.showListingPrice &&
                !this.house.showSoldPrice &&
                this.info.listingStatus == 'Sold'
            );
        }
    }
};
</script>

<style lang="scss">
@import '../../../../theme/mixin.scss';
@import '../../../../theme/media.scss';
.price-container.broker {
    .nodisclosure {
        display: inline-flex;
        .dollar {
            @include color-theme();
        }
        .secret {
            @include color-theme();
        }
    }
    .price-value {
        display: inline-block;
        .price_all {
            display: flex;
            .sold-price {
                display: inline-block;
                color: #505050;
                font-size: 30px;
                line-height: 30px;
                font-family: var(--font-medium);
            }
            .caculator {
                margin-left: 40px;
                font-size: 14px;
                display: inline-block;
            }
        }
        .trend-price {
            margin-top: 10px;
            .initial-price {
                color: #505050;
                font-size: 14px;
                text-decoration: line-through;
            }
            .house-trend {
                margin-left: 10px;
                font-size: 14px;
                font-family: var(--font-bold);
                display: inline-flex;
                align-items: center;
                &:before {
                    margin-right: 4px;
                    font-size: 14px;
                }
                .icon-trend-up,
                .icon-trend-down {
                    display: none;
                    font-size: 12px;
                    margin-right: 4px;
                }
                &.up {
                    color: #96efb4;
                    .icon-trend-up {
                        display: inline;
                    }
                }
                &.down {
                    color: #ff0000;
                    .icon-trend-down {
                        display: inline;
                    }
                }
            }
        }
    }
    .origin-price {
        font-size: 48px;
        color: #191919;
        font-family: var(--font-bold);
        line-height: 58px;
    }
}
@media (max-width: 600px) {
    .price-container.broker {
        .nodisclosure {
            .dollar {
                font-size: 20px;
            }
            .secret {
                font-size: 12px;
            }
            .des {
                font-size: 12px;
            }
        }
        .price-value {
            .price_all {
                .sold-price {
                    font-size: 28px;
                }
                .caculator {
                    display: none;
                }
            }
            .trend-price {
                .initial-price {
                    font-size: 12px;
                }
                .house-trend {
                    font-size: 12px;
                }
            }
        }
        .origin-price {
            display: block;
            line-height: 29px;
            .price-number {
                font-size: 24px;
                font-family: var(--font-bold);
                color: #191919;
            }
        }
    }
}
</style>
